export enum EventCode {
  CV_PAUS = 'CV_PAUS', // Conversation Pause
  CV_RESU = 'CV_RESU', // Conversation Resume
  CV_END = 'CV_END', // Conversation End
  TP_SLCT = 'TP_SLCT', // Select Template
  IS_SLCT = 'IS_SLCT', // Select Issue
  IS_RJCT = 'IS_RJCT', // Reject issue
  RT_ENTR = 'RT_ENTR', // Enter Routine
  RT_CLSE = 'RT_CLSE', // Close Routine
  ST_SHOW = 'ST_SHOW', // Show Step
}

export enum EventObjectType {
  CONVERSATION = 'conversation',
  TEMPLATE = 'template',
  ISSUE = 'issue',
  ROUTINE = 'routine',
  STEP = 'step',
}

export enum EventInput1 {
  ABANDON = 'Abandon',
  FAIL = 'Fail',
  SUCCESS = 'Success',
}

export interface Event {
  id?: string;
  conversationid?: string | number;
  eventCode: EventCode;
  eventDesc?: string;
  objType: EventObjectType;
  objId?: string | number;
  input1?: EventInput1 | string;
  input2?: string;
  input3?: string;
}

export interface ConversationLog {
  id: number;
  creatorId: number;
  creatorName: string;
  createdAt: string;
  statusCode: string;
  statusDesc: string;
  type: string;
  statusGroup1: string;
  lastUpdated: string;
  templateId: string | number;
  templateName: string;
  routineId: number;
  routineName: string;
  durationSystem: number;
  durationInput: number;
  rate: number;
  parentId: number;
  stepId: number;
  stepName: string;
}
